import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: any;
}

export default function Form31b(props: Props) {
  const { register, errors, handleSubmit } = useForm({
    defaultValues: replaceDefaultValues(
      {
        deliveryDate: '',
      },
      props.defaultValues
    ),
  });

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Identificación de la propiedad</h1>

      <FormElement
        name="deliveryDate"
        label="Fecha de entrega*"
        inputRef={register({ required: true })}
        error={errors.deliveryDate}
        elementType="date"
      />

      <FormElement
        label="Carga los documentos de los planos o brochure"
        elementType="custom"
      >
        <input type="file" />
      </FormElement>

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
